// extracted by mini-css-extract-plugin
module.exports = {"donate":"block-module--donate--9ZcHi","title":"block-module--title--2gIcS","text":"block-module--text--UEWqd","buttons":"block-module--buttons--1vpLn"};